export const endPoints = {
  FLAT_MORE: '/v1/flat/more',
  BOOKING_LEAD_FLAT: '/v1/booking-lead-flat'
};
